<template>
  <div :class="['layout', isAndroid, isIOS, isChrome, isSafari, isMobileSafari, props.className]" :style="[props.inlineStyles]">
    <slot />
  </div>
</template>

<script setup>
import MobileDeviceDetect from "mobile-device-detect";

const componentName = "Layout";

// Props types: String, Number, Boolean, Array, Object, Function, Promise
const props = defineProps({
  className: {
    type: String,
  },
  inlineStyles: {
    type: Object,
    default: function () {
      return {
        // Style
      };
    },
  },
});

const isAndroid = ref(MobileDeviceDetect.isAndroid && "is-android");
const isIOS = ref(MobileDeviceDetect.isIOS && "is-ios");
const isChrome = ref(MobileDeviceDetect.isChrome && "is-chrome");
const isSafari = ref(MobileDeviceDetect.isSafari && "is-safari");
const isMobileSafari = ref(MobileDeviceDetect.isMobileSafari && "is-mobile-safari");
</script>

<style lang="scss">
::-webkit-scrollbar {
  width: $specific-scrollbar-thumb-width;
  height: 4px;
  scrollbar-width: $specific-scrollbar-thumb-width;
  scrollbar-color: $specific-scrollbar-thumb-background-color ; // thumb color, track color
}

::-webkit-scrollbar-track {
  padding: $specific-scrollbar-track-py $specific-scrollbar-track-px ;
  border-radius: $rounded-full;
  background: transparent;
  margin: 20px 0;
}

::-webkit-scrollbar-thumb {
  width: $specific-scrollbar-thumb-width;
  border-radius: $rounded-full;
  background-clip: content-box;
  background-color: $specific-scrollbar-thumb-background-color;
}

.layout {
  overflow: overlay;
  /* Parent style   ------------------------------ */
  /* Children style ------------------------------ */
  /* Modifier style ------------------------------ */
}
</style>
